/**
 * Billing Constants
 *
 * Centralized constants for billing and subscription configuration.
 * Shared across all applications (API, frontend, admin).
 *
 * @module @loader/shared-types/constants/billing
 */

export const BILLING_CONSTANTS = {
  /**
   * Number of days for free trial period
   * Applied when a new workspace is created
   */
  TRIAL_DAYS: 30,

  /**
   * Number of days before trial expiry to trigger warnings
   * Used for showing upgrade prompts and sending reminder emails
   */
  TRIAL_WARNING_DAYS: 3,

  /**
   * Number of days to allow access after payment fails (grace period)
   * During this period, users can still access the workspace but will see
   * warnings to update their payment method. After grace period expires,
   * access is blocked until payment is resolved.
   */
  PAST_DUE_GRACE_PERIOD_DAYS: 7,

  /**
   * Default billing period in days for active subscriptions
   * Used when creating a non-trial subscription via admin
   */
  DEFAULT_BILLING_PERIOD_DAYS: 30,
} as const;

/**
 * Cents per dollar for currency conversion
 * Used when converting between cents (Stripe) and dollars (display)
 */
export const CENTS_PER_DOLLAR = 100;
